const answer = () => 42;
